import React, { useEffect, useRef, useState } from 'react'
import ContactForm from './ContactForm'
import { ContactWrapper } from './Styled'
import { Col, Container, Row } from 'react-bootstrap'
import { TextButton, TextWithIcon } from '../../../ui/CustomElements'
import { Box, MainHeading, SpanStyled, SubHeadingStyled, TextStyled, } from '../../../ui/Elements'
import { ContactEmail, ContactInstagram, ContactLinkedin, ContactPhone, ContactTiktok, ContactX, Instagram, LinkedIn, QrScan, SnapChat, Tiktok, Twitter } from '../../../ui/AllImages'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
// import Footer from '../../footer/Footer'
import i18n from '../../../Languages/INEXT'
import { Animate } from 'react-simple-animate'

const Contact = () => {
	const WhatsApp = () => {
        const phoneNumber = '+966555625502';
        const message = 'Hello, this is Hisas';
        const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
        window.open(whatsappURL, '_blank');
    };
	const Map = ""
	const { t } = useTranslation();
	const sectionRef = useRef(null);
		  const [isVisible, setIsVisible] = useState(false);
	const socialIcon = [
			
		{
			img: <ContactX />,
			link: 'https://x.com/',
		},
		{
			img: <ContactTiktok />,
			link: 'https://www.tiktok.com/',
		},
		{
			img: <ContactLinkedin />,
			link: 'https://www.linkedin.com/',
		},
		{
			img: <ContactInstagram />,
			link: 'https://www.instagram.com/',
		},
		
		
		
		// import {ReactComponent as ContactInstagram} from '../assets/images/svg/contactInstagram.svg';
		// import {ReactComponent as ContactX} from '../assets/images/svg/contactX.svg';
		// import {ReactComponent as ContactLinkedin} from '../assets/images/svg/contactLinkedin.svg';
		// import {ReactComponent as ContactTiktok} from '../assets/images/svg/contactTiktok.svg';
		
	]
	useEffect(() => {
			const observer = new IntersectionObserver(
			  ([entry]) => {
				// When visible, set to true
				if (entry.isIntersecting) {
				  setIsVisible(true);
				  observer.disconnect(); // run animation once
				}
			  },
			  {
				threshold: 0.2, // 20% of section visible triggers the animation
			  }
			);
		
			if (sectionRef.current) {
			  observer.observe(sectionRef.current);
			}
		
			return () => observer.disconnect();
		  }, []);
			const start = { opacity: 0, transform: 'translateY(-40px)' };
			const end = { opacity: 1, transform: 'translateY(0)' };
			const start2 = { opacity: 0, transform: 'translateY(100px)' };
			const end2 = { opacity: 1, transform: 'translateY(0)' };
	return (
		<>
			<ContactWrapper id='contact' className='contact-bg container-fluid' ref={sectionRef}>

				<Container>
					<Box className='containerContact'>
						<Row>
							<Col md={12} className='contact-Us-detail'>
								<Box className='contactHeadings'>
									<Animate
																			play={isVisible}
																			duration={1}
																			delay={.5}
																			start={start}
																			end={end}
																		>
									<MainHeading className='main-heading' size="45px" color="var(--themeColor)">
										{t('ContactHeading')}
									</MainHeading>
									</Animate>
								</Box>
							</Col>
							<Col lg={6} md={12} className='contact-Us-detail'>
							<Animate
																			play={isVisible}
																			duration={1}
																			delay={1}
																			start={start}
																			end={end}
																		>
								<Box className='contect-with-us'>
									
									<ContactForm />
								</Box>
								</Animate>
							</Col>
							<Col lg={6} md={12} className='contact-Us'>
							<Animate
																			play={isVisible}
																			duration={1}
																			delay={1.5}
																			start={start}
																			end={end}
																		>
								<Box className='contactDetailCol'>
									<Box className='contactComBox'>
										<Box className='contactComHeading'>
											{t('Address')}
										</Box>
										<SpanStyled className='d-flex addrTxt' family="var(--medium)" color='var(--text)'>
											{t('AddressTxt')}
										</SpanStyled>
									</Box>
									<Box className='contactComBox'>
										<Box className='contactComHeading'>
											{t('contactInfo')}
										</Box>
										<Box className='contact-info'>
											<TextButton clName="dgts engReg wtpBtnCon" icon={ContactPhone} label='+966 55 562 5502' onClick={WhatsApp}  family="var(--medium)" color='var(--text)' />
											<TextWithIcon icon={ContactEmail} title='hisas.realestate@gmail.com' href="mailto:hisas.realestate@gmail.com" color="var(--black)" />
										</Box>
									</Box>
									<Box className='contactComBox contactComBoxScanner'>
										<Box className="scanCtnt">
											<Box className='contactComHeading'>
												{t('commercialRegistration')}
											</Box>
											<Box className='contact-info'>
												<TextButton clName="dgts engReg wtpBtnCon" label='7035818439'  family="var(--medium)" color='var(--text)' />
											</Box>
										</Box>
										<Box className="scanScanner">
											<img src={QrScan} alt="QrScan" />
										</Box>

									</Box>
									<Box className='contactComBox no-border socialWrapper'>
										
										<Box className='Social-links'>
											{
												socialIcon.map((list, key) => (
													<a href={list.link} target="_blank" key={key} className='contact-links'>
														{list.img}
													</a>
												))
											}
										</Box>
										<Box className='contactComHeading w-auto p-0'>
											<TextButton clName="dgts engReg" label='@hisasrealestate'  family="var(--medium)" color='var(--text)' />
										</Box>
									</Box>

									
								</Box>
								</Animate>
								
								
							</Col>
							
						</Row>
					</Box>
				</Container>

			</ContactWrapper>
		</>
	)
}

export default Contact